import 'babel-polyfill'
import "isomorphic-fetch";
import Vue from "vue";
import router from "./plugins/vue-router";
import vuetify from "./plugins/vuetify";
import "./plugins/vue-auth";
import { createProvider } from "@/plugins/vue-apollo";
import store from "./store";
import App from "./App.vue";

const ApolloProvider: any = createProvider().provide();

Vue.config.productionTip = false;
Vue.prototype.apiUrl = process.env.VUE_APP_AXIOS_HTTP;

new Vue({
  router,
  store,
  vuetify,
  provide: ApolloProvider,
  render: h => h(App)
}).$mount("#app");
